var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgWellheads = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1C2 0.447754 2.44775 0 3 0H15C15.5522 0 16 0.447754 16 1C16 1.55225 15.5522 2 15 2H3C2.44775 2 2 1.55225 2 1ZM6 6.5C6 6.22363 6.22388 6 6.5 6H8V3H10V6H11.5C11.7761 6 12 6.22363 12 6.5C12 6.77637 11.7761 7 11.5 7H10H8H6.5C6.22388 7 6 6.77637 6 6.5ZM6.5 8C6.22388 8 6 8.22363 6 8.5C6 8.77637 6.22388 9 6.5 9H11.5C11.7761 9 12 8.77637 12 8.5C12 8.22363 11.7761 8 11.5 8H6.5ZM16 11C16 10.4478 16.4478 10 17 10C17.5522 10 18 10.4478 18 11V17C18 17.5522 17.5522 18 17 18C16.4478 18 16 17.5522 16 17V11ZM1 10C0.447754 10 0 10.4478 0 11V17C0 17.5522 0.447754 18 1 18C1.55225 18 2 17.5522 2 17V11C2 10.4478 1.55225 10 1 10ZM3 12V16H5L5.26575 15.9985L5.49719 15.9971L5.60193 15.9976C6.15161 16.002 6.72217 16.2505 7.29285 16.499C7.55066 16.6113 7.80859 16.7236 8.06458 16.8135C8.38049 16.9238 8.69348 17 9 17C9.15491 17 9.3114 16.9805 9.46912 16.9468C9.87646 16.8604 10.2919 16.6797 10.7072 16.499C10.9564 16.3906 11.2056 16.2822 11.453 16.1938C11.7721 16.0801 12.0884 16 12.3981 15.9976C12.588 15.9961 12.7903 16 13 16H15V12H12C10.8954 12 10 11.1045 10 10H8C8 11.1045 7.10461 12 6 12H3ZM6.5 13C6.22388 13 6 13.2236 6 13.5C6 13.6216 6.04346 13.7334 6.11572 13.8203C6.20752 13.9302 6.34558 14 6.5 14H11.5C11.6556 14 11.7946 13.9292 11.8862 13.8179C11.9318 13.7627 11.9656 13.6973 11.9841 13.6255C11.9945 13.5854 12 13.5435 12 13.5C12 13.2236 11.7761 13 11.5 13H6.5Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWellheads, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wellheads.b6ab3f76.svg";
export { ForwardRef as ReactComponent };